// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discord-bot-page {
  padding: 24px;
  max-width: 800px;
  color: var(--text-primary, #e2e8f0);
}

.discord-bot-page h2 {
  margin: 0 0 8px;
  font-size: 1.4rem;
  color: var(--text-primary, #f1f5f9);
}

.discord-bot-page h3 {
  margin: 0 0 12px;
  font-size: 1rem;
  color: var(--text-secondary, #94a3b8);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.discord-description {
  margin: 0 0 20px;
  color: var(--text-secondary, #94a3b8);
  font-size: 0.9rem;
}

.discord-section {
  background: var(--card-bg, #1e293b);
  border: 1px solid var(--border-color, #334155);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}

.discord-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.bot-status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.bot-status-badge.online {
  background: rgba(16, 185, 129, 0.2);
  color: #10b981;
  border: 1px solid #10b981;
}

.bot-status-badge.offline {
  background: rgba(100, 116, 139, 0.2);
  color: #64748b;
  border: 1px solid #64748b;
}

.discord-field {
  margin-bottom: 16px;
}

.discord-toggle-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.discord-toggle-row .field-label {
  margin: 0;
}

.field-label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.85rem;
  color: var(--text-secondary, #94a3b8);
  font-weight: 500;
}

.discord-input {
  width: 100%;
  padding: 8px 12px;
  background: var(--input-bg, #0f172a);
  border: 1px solid var(--border-color, #334155);
  border-radius: 6px;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.9rem;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.discord-input:focus {
  outline: none;
  border-color: var(--secondary-color, #4f46e5);
}

.discord-hint {
  margin: 6px 0 0;
  font-size: 0.78rem;
  color: var(--text-muted, #64748b);
}

/* Toggle switch */
.toggle {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  inset: 0;
  background: #334155;
  border-radius: 24px;
  transition: background 0.2s;
}

.toggle-slider::before {
  content: '';
  position: absolute;
  left: 3px;
  top: 3px;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle input:checked + .toggle-slider {
  background: var(--secondary-color, #4f46e5);
}

.toggle input:checked + .toggle-slider::before {
  transform: translateX(18px);
}

/* Role list */
.role-list {
  margin-bottom: 16px;
}

.role-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 28px;
  margin-bottom: 8px;
}

.role-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px 3px 10px;
  background: var(--secondary-color, #4f46e5);
  border-radius: 14px;
  font-size: 0.78rem;
  color: #fff;
}

.role-tag-remove {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: 0 2px;
  font-size: 0.8rem;
  line-height: 1;
}

.role-tag-remove:hover {
  color: #fff;
}

.role-input-row {
  display: flex;
  gap: 8px;
}

.role-input-row .discord-input {
  flex: 1 1;
}

/* Buttons */
.discord-btn-primary {
  padding: 9px 20px;
  background: var(--secondary-color, #4f46e5);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: opacity 0.15s;
}

.discord-btn-primary:hover:not(:disabled) {
  opacity: 0.85;
}

.discord-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.discord-btn-secondary {
  padding: 7px 16px;
  background: transparent;
  color: var(--text-primary, #e2e8f0);
  border: 1px solid var(--border-color, #334155);
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.15s, color 0.15s;
}

.discord-btn-secondary:hover {
  border-color: var(--secondary-color, #4f46e5);
  color: var(--secondary-color, #4f46e5);
}

.discord-btn-disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.discord-btn-small {
  padding: 6px 14px;
  background: transparent;
  color: var(--text-secondary, #94a3b8);
  border: 1px solid var(--border-color, #334155);
  border-radius: 6px;
  font-size: 0.82rem;
  cursor: pointer;
  transition: border-color 0.15s;
  white-space: nowrap;
}

.discord-btn-small:hover:not(:disabled) {
  border-color: var(--secondary-color, #4f46e5);
  color: var(--secondary-color, #4f46e5);
}

.discord-btn-small:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.discord-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.discord-save-msg {
  font-size: 0.85rem;
  color: #10b981;
}

/* Per-championship blocks */
.champ-discord-block {
  border: 1px solid var(--border-color, #334155);
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
}

.champ-discord-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  background: var(--input-bg, #0f172a);
  -webkit-user-select: none;
          user-select: none;
}

.champ-discord-header:hover {
  background: rgba(255, 255, 255, 0.03);
}

.champ-discord-name {
  flex: 1 1;
  font-size: 0.9rem;
  color: var(--text-primary, #e2e8f0);
}

.champ-discord-chevron {
  font-size: 0.7rem;
  color: var(--text-muted, #64748b);
}

.champ-discord-body {
  padding: 16px;
  background: var(--card-bg, #1e293b);
  border-top: 1px solid var(--border-color, #334155);
}

/* Category management */
.category-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.category-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.category-name-input {
  flex: 1 1;
}

.category-key-hint {
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
  white-space: nowrap;
  min-width: 80px;
}

.category-remove-btn {
  flex-shrink: 0;
}

.category-add-row {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.category-add-row .discord-input {
  flex: 1 1;
}

/* Message routing table */
.routing-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.routing-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.routing-label {
  flex: 1 1;
  font-size: 0.87rem;
  color: var(--text-primary, #e2e8f0);
  min-width: 180px;
}

.routing-select {
  width: 180px;
  flex-shrink: 0;
  padding: 6px 10px;
  cursor: pointer;
}

/* Fixed channel divider */
.channel-fixed-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 16px 0 12px;
}

.channel-fixed-divider span {
  font-size: 0.78rem;
  color: var(--text-muted, #64748b);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.channel-fixed-divider::before,
.channel-fixed-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--border-color, #334155);
}

/* Help section */
.discord-help ol,
.discord-help ul {
  margin: 0 0 16px;
  padding-left: 20px;
  color: var(--text-secondary, #94a3b8);
  font-size: 0.87rem;
  line-height: 1.7;
}

.discord-help p {
  margin: 0 0 8px;
  font-size: 0.87rem;
  color: var(--text-secondary, #94a3b8);
}
`, "",{"version":3,"sources":["webpack://./src/components/DiscordBot.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,8CAA8C;EAC9C,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mCAAmC;EACnC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC","sourcesContent":[".discord-bot-page {\r\n  padding: 24px;\r\n  max-width: 800px;\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.discord-bot-page h2 {\r\n  margin: 0 0 8px;\r\n  font-size: 1.4rem;\r\n  color: var(--text-primary, #f1f5f9);\r\n}\r\n\r\n.discord-bot-page h3 {\r\n  margin: 0 0 12px;\r\n  font-size: 1rem;\r\n  color: var(--text-secondary, #94a3b8);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.discord-description {\r\n  margin: 0 0 20px;\r\n  color: var(--text-secondary, #94a3b8);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.discord-section {\r\n  background: var(--card-bg, #1e293b);\r\n  border: 1px solid var(--border-color, #334155);\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.discord-status-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.bot-status-badge {\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.bot-status-badge.online {\r\n  background: rgba(16, 185, 129, 0.2);\r\n  color: #10b981;\r\n  border: 1px solid #10b981;\r\n}\r\n\r\n.bot-status-badge.offline {\r\n  background: rgba(100, 116, 139, 0.2);\r\n  color: #64748b;\r\n  border: 1px solid #64748b;\r\n}\r\n\r\n.discord-field {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.discord-toggle-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.discord-toggle-row .field-label {\r\n  margin: 0;\r\n}\r\n\r\n.field-label {\r\n  display: block;\r\n  margin-bottom: 6px;\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary, #94a3b8);\r\n  font-weight: 500;\r\n}\r\n\r\n.discord-input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  background: var(--input-bg, #0f172a);\r\n  border: 1px solid var(--border-color, #334155);\r\n  border-radius: 6px;\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-size: 0.9rem;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.discord-input:focus {\r\n  outline: none;\r\n  border-color: var(--secondary-color, #4f46e5);\r\n}\r\n\r\n.discord-hint {\r\n  margin: 6px 0 0;\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n/* Toggle switch */\r\n.toggle {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 42px;\r\n  height: 24px;\r\n  flex-shrink: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.toggle input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.toggle-slider {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: #334155;\r\n  border-radius: 24px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.toggle-slider::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 3px;\r\n  top: 3px;\r\n  width: 18px;\r\n  height: 18px;\r\n  background: #fff;\r\n  border-radius: 50%;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.toggle input:checked + .toggle-slider {\r\n  background: var(--secondary-color, #4f46e5);\r\n}\r\n\r\n.toggle input:checked + .toggle-slider::before {\r\n  transform: translateX(18px);\r\n}\r\n\r\n/* Role list */\r\n.role-list {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.role-tags {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  min-height: 28px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.role-tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 3px 8px 3px 10px;\r\n  background: var(--secondary-color, #4f46e5);\r\n  border-radius: 14px;\r\n  font-size: 0.78rem;\r\n  color: #fff;\r\n}\r\n\r\n.role-tag-remove {\r\n  background: none;\r\n  border: none;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  cursor: pointer;\r\n  padding: 0 2px;\r\n  font-size: 0.8rem;\r\n  line-height: 1;\r\n}\r\n\r\n.role-tag-remove:hover {\r\n  color: #fff;\r\n}\r\n\r\n.role-input-row {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.role-input-row .discord-input {\r\n  flex: 1;\r\n}\r\n\r\n/* Buttons */\r\n.discord-btn-primary {\r\n  padding: 9px 20px;\r\n  background: var(--secondary-color, #4f46e5);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s;\r\n}\r\n\r\n.discord-btn-primary:hover:not(:disabled) {\r\n  opacity: 0.85;\r\n}\r\n\r\n.discord-btn-primary:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.discord-btn-secondary {\r\n  padding: 7px 16px;\r\n  background: transparent;\r\n  color: var(--text-primary, #e2e8f0);\r\n  border: 1px solid var(--border-color, #334155);\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition: border-color 0.15s, color 0.15s;\r\n}\r\n\r\n.discord-btn-secondary:hover {\r\n  border-color: var(--secondary-color, #4f46e5);\r\n  color: var(--secondary-color, #4f46e5);\r\n}\r\n\r\n.discord-btn-disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n}\r\n\r\n.discord-btn-small {\r\n  padding: 6px 14px;\r\n  background: transparent;\r\n  color: var(--text-secondary, #94a3b8);\r\n  border: 1px solid var(--border-color, #334155);\r\n  border-radius: 6px;\r\n  font-size: 0.82rem;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.discord-btn-small:hover:not(:disabled) {\r\n  border-color: var(--secondary-color, #4f46e5);\r\n  color: var(--secondary-color, #4f46e5);\r\n}\r\n\r\n.discord-btn-small:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.discord-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.discord-save-msg {\r\n  font-size: 0.85rem;\r\n  color: #10b981;\r\n}\r\n\r\n/* Per-championship blocks */\r\n.champ-discord-block {\r\n  border: 1px solid var(--border-color, #334155);\r\n  border-radius: 6px;\r\n  margin-bottom: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.champ-discord-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 16px;\r\n  cursor: pointer;\r\n  background: var(--input-bg, #0f172a);\r\n  user-select: none;\r\n}\r\n\r\n.champ-discord-header:hover {\r\n  background: rgba(255, 255, 255, 0.03);\r\n}\r\n\r\n.champ-discord-name {\r\n  flex: 1;\r\n  font-size: 0.9rem;\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.champ-discord-chevron {\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n.champ-discord-body {\r\n  padding: 16px;\r\n  background: var(--card-bg, #1e293b);\r\n  border-top: 1px solid var(--border-color, #334155);\r\n}\r\n\r\n/* Category management */\r\n.category-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.category-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.category-name-input {\r\n  flex: 1;\r\n}\r\n\r\n.category-key-hint {\r\n  font-size: 0.75rem;\r\n  color: var(--text-muted, #64748b);\r\n  white-space: nowrap;\r\n  min-width: 80px;\r\n}\r\n\r\n.category-remove-btn {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.category-add-row {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.category-add-row .discord-input {\r\n  flex: 1;\r\n}\r\n\r\n/* Message routing table */\r\n.routing-table {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.routing-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.routing-label {\r\n  flex: 1;\r\n  font-size: 0.87rem;\r\n  color: var(--text-primary, #e2e8f0);\r\n  min-width: 180px;\r\n}\r\n\r\n.routing-select {\r\n  width: 180px;\r\n  flex-shrink: 0;\r\n  padding: 6px 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Fixed channel divider */\r\n.channel-fixed-divider {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 16px 0 12px;\r\n}\r\n\r\n.channel-fixed-divider span {\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted, #64748b);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  white-space: nowrap;\r\n}\r\n\r\n.channel-fixed-divider::before,\r\n.channel-fixed-divider::after {\r\n  content: '';\r\n  flex: 1;\r\n  height: 1px;\r\n  background: var(--border-color, #334155);\r\n}\r\n\r\n/* Help section */\r\n.discord-help ol,\r\n.discord-help ul {\r\n  margin: 0 0 16px;\r\n  padding-left: 20px;\r\n  color: var(--text-secondary, #94a3b8);\r\n  font-size: 0.87rem;\r\n  line-height: 1.7;\r\n}\r\n\r\n.discord-help p {\r\n  margin: 0 0 8px;\r\n  font-size: 0.87rem;\r\n  color: var(--text-secondary, #94a3b8);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
